import { Theme } from 'src/app/shared/models/theme';

let theme = new Theme();
theme.name = 'shopper';
theme.addStyleDependency(
  'shopper-tailwind',
  '/assets/tailwind.min.css',
  '3.0.1',
  'tailwind'
);
theme.addFontDependency('tailwind-font', 'Inter');
export const shopperTheme = theme;
